import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Typography } from '@mui/material';
import { IoCloseSharp } from "react-icons/io5";
import { useState } from 'react';
import { MakeSignonPayment } from 'API/DS_Wallet/api';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function SignOnAlertDialog(props) {
  const [Loading,setLoading]=useState(false)
  const [open, setOpen] = React.useState(false);
  const[AlertType,setAlertType]=useState('success')
  const [AlertMessage,setAlertMessage]=useState(null)

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  
const handlePost=()=>{
  MakeSignonPayment(props.SelectedData.user_id,props.SelectedData.installment_1_pending_amount,setLoading,props.handleClose,handleClick,setAlertMessage,setAlertType)
}

  return (
    <React.Fragment>

<Snackbar anchorOrigin={{horizontal:'right',vertical:'top'}} open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={AlertType}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {AlertMessage}
        </Alert>
      </Snackbar>
      
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
       
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
              <Typography variant='h4'> Payment  of ₹ {props.SelectedData?props.SelectedData.installment_1_pending_amount:''} will be deducted from your wallet balance</Typography>
          </DialogContentText>
          <div style={{
            position:'absolute',
            right:'5px',
            top:'5px',
            cursor:'pointer',
            fontSize:'22px',
          }}
          
          >
            <IoCloseSharp onClick={props.handleClose} />
          </div>
        </DialogContent>
        <DialogActions sx={{justifyContent:'center'}}>
          {
            Loading?
            <Button color='secondary' disabled={true} size='small' variant='contained' onClick={props.handleClose} autoFocus>
            processing...
          </Button>
          :
            <Button color='secondary' size='small' variant='contained' onClick={()=>handlePost()} autoFocus>
            Click here to confirm
          </Button>
          }
          
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
